import { render, staticRenderFns } from "./pos-advanced-paid.vue?vue&type=template&id=6d25afc4"
import script from "./pos-advanced-paid.vue?vue&type=script&lang=js"
export * from "./pos-advanced-paid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports